import { and, eq, gt } from 'ember-truth-helpers';
import { t } from 'ember-intl';
import can from 'ember-can/helpers/can';
import {
  HdsPageHeader,
  HdsButton,
  HdsAlert,
} from '@hashicorp/design-system-components/components';
import { CoreLayoutMain, BreadcrumbsContainer, Flex } from 'core/components';
import ListTable from 'hcp/components/iam/groups/members/list-table';

const Members = <template>
  {{#let
    (and (eq @scimEnabled true) (eq @group.scimSynchronized true))
    as |scimManaged|
  }}
    <CoreLayoutMain>
      <:header>
        <HdsPageHeader as |PH|>
          <PH.Breadcrumb>
            <BreadcrumbsContainer />
          </PH.Breadcrumb>
          <PH.IconTile @icon="users" />
          <PH.Title>
            {{t "components.page.access-control.groups.detail.members.title"}}
          </PH.Title>
          <PH.Actions>
            {{#if
              (and
                (can "delete groups")
                (gt @eligibleMembers.length 0)
                (gt @members.length 0)
                (eq scimManaged false)
              )
            }}
              <HdsButton
                @route="cloud.access-control.groups.detail.members.add"
                @text={{t
                  "components.page.access-control.groups.detail.members.actions.add-group-members"
                }}
                @icon="plus"
                @iconPosition="leading"
                data-test-groups-organization-detail-add-members-cta
              />
            {{/if}}
          </PH.Actions>
        </HdsPageHeader>
      </:header>
      <:body>
        {{#if @members.length}}
          <Flex @direction="row">
            <Flex @grow={{1}}>
              <ListTable
                @group={{@group}}
                @isProjectContext={{@isProjectContext}}
                @members={{@members}}
              />
            </Flex>
          </Flex>
        {{else}}
          <HdsAlert @type="inline" data-test-groups-project-alert as |A|>
            <A.Title>
              {{t
                "components.page.access-control.groups.detail.members.empty.title"
              }}
            </A.Title>
            <A.Description>
              {{t
                "components.page.access-control.groups.detail.members.empty.description"
              }}
            </A.Description>
          </HdsAlert>
        {{/if}}
      </:body>
    </CoreLayoutMain>
  {{/let}}
</template>;

export default Members;
